import { render } from "./Input.vue?vue&type=template&id=00b52d4f"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"

import "./Input.vue?vue&type=style&index=0&id=00b52d4f&lang=scss"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__